import { render, staticRenderFns } from "./ProfileBlock.vue?vue&type=template&id=a189fbd4&scoped=true"
import script from "./ProfileBlock.vue?vue&type=script&lang=js"
export * from "./ProfileBlock.vue?vue&type=script&lang=js"
import style0 from "./ProfileBlock.vue?vue&type=style&index=0&id=a189fbd4&prod&scoped=true&lang=css"
import style1 from "./ProfileBlock.vue?vue&type=style&index=1&id=a189fbd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a189fbd4",
  null
  
)

export default component.exports